export const styles = theme => ({
  inputContainer: {
    margin: '0 0 1rem 0',
    padding: '0 1rem',
  },
});
